import { Check, ChevronDown, Edit05, Eye, ShieldPlus, Trash02 } from "@untitledui/icons";
import type { ComponentType } from "react";
import { Button } from "@/components/base/buttons/button";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";

export type ReviewRiskAction =
  | "approve_identified_risks"
  | "reject_identified_risks"
  | "edit_identified_risks"
  | "add_new_risk";

export const REVIEW_RISK_ACTIONS: readonly ReviewRiskAction[] = [
  "approve_identified_risks",
  "reject_identified_risks",
  "edit_identified_risks",
  "add_new_risk",
] as const;

export const getReviewRiskActionLabel = (action: ReviewRiskAction): string => {
  switch (action) {
    case "approve_identified_risks":
      return "Approve identified risks";
    case "reject_identified_risks":
      return "Reject identified risks";
    case "edit_identified_risks":
      return "Edit identified risks";
    case "add_new_risk":
      return "Add New Risk";
  }
};

export const getReviewRiskActionIcon = (action: ReviewRiskAction): ComponentType<{ className?: string }> => {
  switch (action) {
    case "approve_identified_risks":
      return Check;
    case "reject_identified_risks":
      return Trash02;
    case "edit_identified_risks":
      return Edit05;
    case "add_new_risk":
      return ShieldPlus;
  }
};

interface ReviewRiskDropdownProps {
  onSelectAction: (action: ReviewRiskAction) => void;
  disabled?: boolean;
}

export const ReviewRiskDropdown = ({ onSelectAction, disabled }: ReviewRiskDropdownProps) => {
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild disabled={disabled}>
        <Button
          isDisabled={disabled}
          iconLeading={<Eye className="w-4 h-4" />}
          iconTrailing={<ChevronDown className="w-4 h-4" />}
        >
          Review Risk
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" sideOffset={8}>
        <ReviewRiskMenuItems onSelectAction={onSelectAction} />
      </DropdownMenuContent>
    </DropdownMenu>
  );
};

export const ReviewRiskMenuItems = ({ onSelectAction }: ReviewRiskDropdownProps) => {
  return (
    <>
      {REVIEW_RISK_ACTIONS.map((action) => {
        const Icon = getReviewRiskActionIcon(action);
        return (
          <DropdownMenuItem
            key={action}
            onClick={() => onSelectAction(action)}
            className="flex items-center gap-2 py-2"
          >
            <Icon className="w-4 h-4 text-fg-quaternary shrink-0" />
            <span className="text-secondary font-semibold">{getReviewRiskActionLabel(action)}</span>
          </DropdownMenuItem>
        );
      })}
    </>
  );
};
